// extracted by mini-css-extract-plugin
export default {"title":"FilterStudents_title__PWbOj","list":"FilterStudents_list__cFdjJ","list_item":"FilterStudents_list_item__BG9To"};